import React from 'react';
import Type from 'prop-types';
import { Button, Chip } from "@mui/material";
import { useTranslation } from 'hooks';
import FilterChips from '../FilterChips';
import styles from './FilterBar.module.css';

const FilterBar = (props) => {
  const { filtersBy, getFilterValue, children, onOpen, onReset, onResetAll } = props;
  const { t } = useTranslation();
  const filterIds = Object.keys(filtersBy);

  const handleResetFilter = (filter) => () => {
    onReset(filter);
  };

  const renderChips = () => {
    return (
      <FilterChips singleLine>
        <div className={styles.filterWrapper}>
          {filterIds.map((filterId) => {
            if (filterId === 'query') return null;
            const filterValue = getFilterValue(filterId, filtersBy);
            const filter = { id: filterId, name: t(filterId) };
            const { hasValue, filterName } = filterValue;
            return (
              <Chip
                key={filterId}
                color={hasValue ? 'primary' : 'default'}
                label={filterName}
                className={styles.tag}
                onClick={onOpen(filter)}
                onDelete={hasValue ? handleResetFilter(filter) : null}
                data-testid={`open${filterId}Filter`}
                clickable
              />
            );
          })}

          <Button
            color="primary"
            className={styles.resetButton}
            onClick={onResetAll}
            data-testid="filterResetAllBtn"
          >
            {t('reset')}
          </Button>
        </div>
      </FilterChips>
    );
  };

  return (
    <>
      {renderChips()}
      {children}
    </>
  );
};

FilterBar.propTypes = {
  filtersBy: Type.object.isRequired, // eslint-disable-line react/forbid-prop-types
  onOpen: Type.func.isRequired,
  getFilterValue: Type.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  children: Type.object.isRequired,
  onReset: Type.func.isRequired,
  onResetAll: Type.func.isRequired,
};

export default FilterBar;
